import { MakeCall } from './createMakeCall';
import { ListingVideo } from './types/Listing';

const confirmListingVideoUpload =
  (makeCall: MakeCall) => (listingId: number, videoId: number) =>
    makeCall<ListingVideo[]>(
      'PUT',
      `/api/v2/listing/${listingId}/video/${videoId}/confirm`,
    );
export { confirmListingVideoUpload };
